import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";

export function HouseholdECookingStudy() {
  return (
    <div className="art-page">
      <SEO
        title="Household eCooking Study — Energy Implications of Electric Cooking — CIRCODU Uganda"
        description="CIRCODU examined energy implications of full household transition to electric cooking, analyzing device combinations, costs at different tariff levels, and barriers to complete biomass fuel replacement in Ugandan homes."
        keywords="household eCooking, electric cooking, energy implications, appliance combinations, tariff analysis, cooking tasks, barriers to eCooking, Uganda, CIRCODU, MECS, clean cooking, energy transition, sustainable development, household energy use Uganda, electric cooking study Uganda, eCooking appliance combinations Uganda, electricity tariff analysis Uganda, barriers to eCooking Uganda"
        url="/Household-eCooking-Study-Energy-Implications-of-Cooking-Entirely-with-Electricity"
        datePublished="2023-01-14"
      />

      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Household eCooking Study — Energy Implications of Cooking Entirely
              with Electricity
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>
      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              January 14, 2023
            </div>
            <h1 className="art-title">
              Household eCooking Study — Energy Implications of Cooking Entirely
              with Electricity
            </h1>
            <div className="texty">
              <h2 className="art-subheading">Overview</h2>
              <p>
                In late 2022 and early 2023, CIRCODU conducted an in-depth study
                examining the energy implications of households transitioning to
                cooking entirely with electricity — an expansion of earlier
                MECS-commissioned research into the practical realities of full
                eCooking adoption in Ugandan homes.
              </p>
              <p>
                As interest in eCooking grows globally, a critical knowledge gap
                has been the question of what it actually costs and demands in
                practice for a household to meet all its cooking needs
                electrically — not just to supplement biomass with an occasional
                electric appliance, but to make electricity the primary or
                exclusive cooking fuel. This study was designed to fill that gap
                for the Ugandan context.
              </p>
              <h2 className="art-subheading">CIRCODU's Role</h2>
              <p>
                The study extended previous research by examining the use of
                multiple electric devices in combination — recognising that
                households deploy different appliances (electric pressure
                cookers, rice cookers, hotplates) for different dishes, and that
                the economics of eCooking depend critically on how this device
                mix is deployed in practice.
              </p>
              <p>CIRCODU collected data on:</p>
              <ol>
                <li>
                  The energy consumption of different device combinations.
                </li>
                <li>Costs incurred at different electricity tariff levels.</li>
                <li>Cooking tasks best suited to each technology.</li>
                <li>
                  Barriers that arise when households attempt to meet all
                  cooking needs electrically.
                </li>
              </ol>
              <p>
                The findings contributed to a more granular understanding of the
                upfront and ongoing cost dynamics of eCooking, and helped
                identify which combinations of devices offer the best value for
                Ugandan households at different income levels — insight directly
                relevant to technology selection, subsidy design, and consumer
                education in Uganda's growing eCooking sector.
              </p>
            </div>
            <div className="art-cta">
              <p>
                For more information about CIRCODU's eCooking research, contact
                us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
